class MultipleQuotes {
    static init() {
        // If items per page number change, change also css items hidden in multiplequote.scss
        this.itemsPerPage = 3;
        this.listItems = document.querySelectorAll(".js-quotes-list");
        this.btnMore = document.querySelectorAll(".js-btn-more");
        if (this.listItems.length > 0) {
            if (this.listItems[0].children.length > this.itemsPerPage) {
                this.listItems[0].classList.add('closed');
                this.btnMore[0].addEventListener('click', () => {
                    this.listItems[0].classList.remove('closed');
                    this.btnMore[0].style.display = "none";
                })
            } else {
                this.btnMore[0].style.display = "none";
            }
        }
    }
}
export default MultipleQuotes;


// WEBPACK FOOTER //
// ./src/scripts/components/multiplequotes.js